/**
 * Compact date label used by analytics-v2 chart X-axes.
 *
 * Formats a `'YYYY-MM-DD'` API date (parsed at UTC midnight) as `'Sep 21'`.
 * Uses `en-US` explicitly so tests and displays are locale-stable — dashboards
 * running on non-en machines should still surface English month labels
 * consistent with the rest of the widget copy.
 *
 * Returns the input unchanged when it can't be parsed as a date, so a
 * malformed API date doesn't crash the chart.
 */
export function shortDate(isoDate: string): string {
  const d = new Date(`${isoDate}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
